import Vue from 'vue';
import Router from 'vue-router';
import constantRoutes from './constantRoutes';
Vue.use(Router);

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */

if (process.env.NODE_ENV === 'development') {
  const files = require.context('../views/', true, /\.vue$/);
}

const createRouter = (newRouterList = []) =>
  new Router({
    mode: 'history',
    scrollBehavior: { y: 0 },
    routes: [...constantRoutes, ...newRouterList],
    scrollBehavior(to, from, savedPosition) {
      // return 期望滚动到哪个的位置
      return { top: 0 };
    },
  });

const router = createRouter();

export function resetRouter(newRouterList) {
  const newRouter = createRouter(newRouterList);
  router.matcher = newRouter.matcher; // reset router
}
export { constantRoutes, createRouter };
export default router;
